export default __webpack_public_path__ + "static/media/code-core.65135289.svg";